const envs = {
   'staged.tiny-mesh.com':        'http://http.stage.highlands.tiny-mesh.com/v2',
   'http.cloud-ng.tiny-mesh.com': 'https://http.cloud-ng.tiny-mesh.com/v2',
   localhost:                     window.location.protocol + '//localhost:4000',
   'next-gen.tiny-mesh.com':      window.location.protocol + '//next-gen.tiny-mesh.com/v2',
   'next-gen.test':               window.location.protocol + '//next-gen.test/v2',
   'ip6-loopback':                window.location.protocol + '//next-gen.tm/v2'
}
const fallback = window.location.protocol + '//http.' + window.location.hostname + '/v2'

const base = window.location.search.match(/BASE_URL=([^&#]*)/)

if (base) {
   sessionStorage.BASE_URL = base[1]
}

export default {
   BASE_URL: sessionStorage.BASE_URL || envs[window.location.hostname] || fallback
}



// WEBPACK FOOTER //
// lib/api/constants.js